import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import DateAndTime from 'date-and-time';
import { Outlet, useParams } from 'react-router-dom';

import PageLayout from 'components/Layout/PageLayout';
import oIconLibrary from 'utils/iconLibrary';
import oWnApi from 'utils/WnApi';
import LoadingZone from 'components/LoadingZone';
import {
  fnFormatEventDate,
  fnFormatEventTime,
} from 'components/MyEvents/helpers';
import EventAttendeesList from './EventAttendeesList';
import MyParty from './MyParty';
import EventContact from './EventContact';
import EventLocation from './EventLocation';
import AddToCalendar from './AddToCalendar';
import EventDescription from './EventDescription';

const EventDetails = () => {
  const { eventSlug } = useParams();
  const [oEvent, fnSetEvent] = useState(null);

  useEffect(() => {
    const fnGetEventDetails = async () => {
      const oResponse = await oWnApi.get(`events/${eventSlug}`);
      if (oResponse.status === 200) {
        fnSetEvent(oResponse.data);
      }
    };
    if (!oEvent) {
      fnGetEventDetails();
    }
  }, [eventSlug, oEvent]);

  let sYear = '';
  if (oEvent) {
    const oStartDate = DateAndTime.parse(
      oEvent.START_DATE_TIME,
      'YYYY-MM-DDTHH:mm:ss'
    );
    sYear = DateAndTime.format(oStartDate, 'YYYY');
  }

  return (
    <PageLayout sTitle='Event Details' className='eventDetails__Page'>
      <LoadingZone isLoading={!oEvent}>
        <div className='eventDetails__sectionWithLine'>
          <p className='event__dateBlock'>
            <span className='t-label'>
              {fnFormatEventDate(
                oEvent?.START_DATE_TIME,
                oEvent?.END_DATE_TIME
              )}
            </span>
            <br />
            <span>{sYear}</span>
          </p>
          <h2 className='eventDetails___eventTitle t-paragraph--large'>
            {oEvent?.TITLE}
          </h2>
          <p className='eventDetails__time'>
            <FontAwesomeIcon icon={oIconLibrary.fontAwesome.clock} />{' '}
            {fnFormatEventTime(oEvent?.START_DATE_TIME, oEvent?.END_DATE_TIME)}
          </p>
          {oEvent?.LOCATION && <EventLocation oLocation={oEvent?.LOCATION} />}
        </div>
        {oEvent?.MY_PARTY && <MyParty oParty={oEvent?.MY_PARTY} />}
        {oEvent?.DESCRIPTION && (
          <EventDescription sDescription={oEvent.DESCRIPTION} />
        )}
        {oEvent?.CONTACT && <EventContact oContact={oEvent?.CONTACT} />}
        <EventAttendeesList aAttendees={oEvent?.ATTENDEES} />
        {oEvent && <AddToCalendar oEvent={oEvent} />}
      </LoadingZone>
      {/* This tells <BrowserRouter /> where to render nested routes - here, the public profile modal */}
      <Outlet />
    </PageLayout>
  );
};

export default EventDetails;
